import { Component, OnInit } from '@angular/core';
import { IonicPage, NavController, NavParams, ViewController } from 'ionic-angular';
import { clientes } from '../../models/clientes';
import { Storage } from '@ionic/storage'
import { ClientesProvider } from '../../providers/clientes/clientes';
import { UtilsProvider } from '../../providers/utils/utils';
import { CajaProvider } from '../../providers/caja/caja';
import { NUBE_AWS } from '../../config/url.servicio';
import { AppState } from '../../app/app.reducer';
import { Store } from '@ngrx/store';
import { ClienteSelectRedux } from '../../providers/redux/clienteselect/clienteselect';
import { UtilsRedux } from '../../providers/redux/utils/utils'

@IonicPage()
@Component({
  selector: 'page-cliente-rapido',
  templateUrl: 'cliente-rapido.html',
  providers: [ClienteSelectRedux, UtilsRedux]
})
export class ClienteRapidoPage implements OnInit {
  telefonoClienteRapido: string = ""
  nombreClienteRapido: string = ""
  direccionClienteRapido: string = ""
  clientesSelect = [];
  listaClientes = [];
  correoElectronico:string =""
  tipoIdentificacion:string ="C"
  identificacion:string =""
  digito:string =""
  segundoNombre:string =""
  manejaInteresesEnCuentasDeCobro: boolean = false;
  constructor(public navCtrl: NavController, public navParams: NavParams,
    public viewControllers:ViewController,
    public storage: Storage,
    public providerClientes: ClientesProvider,
    public utilsMensajero:UtilsProvider,
    public servicio: CajaProvider,
    private store: Store<AppState>,
    public clienteSelectRedux: ClienteSelectRedux,
    public utilsRedux: UtilsRedux,) {
  }

  ngOnInit() {
    let datosCreditos = localStorage.getItem('datosCreditos')
    let datosCredito = JSON.parse(datosCreditos)
    if(datosCredito && datosCredito["manejaInteresesEnCuentasDeCobro"]) {
      this.manejaInteresesEnCuentasDeCobro = datosCredito["manejaInteresesEnCuentasDeCobro"].seleccion === 'S' ? true : false
    }
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad ClienteRapidoPage');
  }
  dismiss(){
    this.viewControllers.dismiss();
  }

  limpiarClienteRapido(){

    this.telefonoClienteRapido = ""
    this.nombreClienteRapido = ""
    this.direccionClienteRapido = ""
    this.correoElectronico = ""
    this.tipoIdentificacion ="C"
    this.identificacion=""
    this.digito=""
    this.segundoNombre = ""

  }

  guardarClienteRapido(){

    let datosCliente: clientes = {
      tipoIdentificacion : this.tipoIdentificacion = '' ? 'C': this.tipoIdentificacion,
      identificacion : this.identificacion == '' ? '0': this.identificacion,
      digito : this.digito,
      fechaExpedicion : '',
      primerApellido : '',
      numeroTelefono : this.telefonoClienteRapido,
      segundoApellido : '',
      primerNombre : this.nombreClienteRapido,
      segundoNombre : this.segundoNombre,
      nombreCompleto : this.nombreClienteRapido,
      fechaIngreso : '',
      estado : 'A',
      direccion : this.direccionClienteRapido,
      queHago: "I",
      nombreTabla: "clientes",
      name: "dataDynamicCrud",
      correoElectronico: this.correoElectronico
    }
    this.storage.get('companiasId').then((val) => {
      datosCliente['companiasId']  = val
    this.providerClientes.guardar(datosCliente)
      .subscribe(
      (res:any) => {
        this.limpiarClienteRapido()
        this.viewControllers.dismiss([{data:'values'}]);
      },
      err => {
        console.log(err)}
      )
    })

  }
  async buscarClientes() {
    this.storage.get('companiasId').then((val) => {
       this.servicio.buscarClientesAll(val)
      .subscribe((data: any)=> {
        let clienteJson = NUBE_AWS ? JSON.parse(data['_body']) : data[0]
        let clienteResponse = NUBE_AWS ? clienteJson.data[0] : data[0]
        this.clientesSelect = clienteResponse
        this.listaClientes = clienteResponse
        this.viewControllers.dismiss(this.listaClientes);
      },
       error=> {
         console.log(error);
       })
      });
  }
}



// WEBPACK FOOTER //
// ./src/pages/cliente-rapido/cliente-rapido.ts